
import {$AjaxJson} from '../lf'
import {$Urlpath,$UrlApipath} from '../config/config'



export const  RegionRequest = {
      GetRegion(func,ID) {
           $AjaxJson($UrlApipath+"Region/GetRegion",{ID:ID},function (d) {
                func(d)
           })
      },
      AddRegion(func,obj) {
               $AjaxJson($UrlApipath+"Region/AddRegion",obj,function (d) {
                    func(d)
               })
      },UpdateRegion(func,obj) {
               $AjaxJson($UrlApipath+"Region/UpdateRegion",obj,function (d) {
                    func(d)
               })
      },
      SearchRegion(func,obj) {
               $AjaxJson($UrlApipath+"Region/SearchRegion",obj,function (d) {
                    func(d)
               })
      },
      SetRegionIsCommon(func,ID,IsCommon) {
               $AjaxJson($UrlApipath+"Region/SetRegionIsCommon",{ID:ID,IsCommon:IsCommon},function (d) {
                    func(d)
               })
      },
      SetRegionStatus(func,ID,Status) {
               $AjaxJson($UrlApipath+"Region/SetRegionStatus",{ID:ID,Status:Status},function (d) {
                    func(d)
               })
      },
      SetRegionIsPickup(func,ID,IsPickup) {
               $AjaxJson($UrlApipath+"Region/SetRegionIsPickup",{ID:ID,IsPickup:IsPickup},function (d) {
                    func(d)
               })
      },
}







// WEBPACK FOOTER //
// ./src/request/Region.js